/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {type ResizableProps} from '../../../editor/types'

export type GroupLayout = 'row' | 'column'
export type GroupAlignment = 'start' | 'center' | 'end'
export type GroupHorizontalAlignment = GroupAlignment | 'distribute'

interface AllAlignments {
  layout: GroupLayout
  alignment: GroupHorizontalAlignment
  verticalAlignment: GroupAlignment
}

export const defaultAlignment: AllAlignments = {
  layout: 'row',
  alignment: 'start',
  verticalAlignment: 'start',
}

export type GroupBlockProps = {
  isColumn?: boolean
  layout?: GroupLayout
  background?: string
  borderColor?: string
  roundedCorners?: boolean
  alignment?: GroupHorizontalAlignment
  verticalAlignment?: GroupAlignment
  resizable?: boolean
} & ResizableProps
